export default "__VITE_ASSET__D2zzrIqr__"